import {Guid} from './Guid';
import {BaseIdQuery} from './base.query';
import {Transform} from "class-transformer";
export interface IIdCode {
  Id: string;
  Code: string
}

// @dynamic
export class BaseIdModel {
  @Transform(({obj}) => (obj.Id === Guid.EMPTY || obj.Id === '') ? null : obj.Id, {toClassOnly: true})
  Id: string;
  constructor() {
    this.Id = Guid.create();
  }
}

export interface IWithDisplayName {
  get DisplayName(): string;
}

export class BaseIdCodeModel extends BaseIdModel implements IIdCode {
  Code: string;

  constructor(init?: Partial<BaseIdCodeModel>) {
    super();
    Object.assign(this, init);
  }
}

export class IdTextModel extends BaseIdModel {
  Text: string;

  constructor(init?: Partial<IdTextModel>) {
    super();
    Object.assign(this, init);
  }
}

export class IdTextStateModel extends IdTextModel {
  State: boolean;
  constructor(init?: Partial<IdTextStateModel>) {
    super();
    Object.assign(this, init);
  }
}

export class IdTextValueModel extends IdTextModel {
  Value: string;
}

export class IdCodeNameModel extends BaseIdCodeModel {
  Name: string;

  get DisplayName(): string {
    return this._displayName ?? BaseIdQuery.getDisplayName([this.Code, this.Name]);
  }
  set DisplayName(value: string) {
    this._displayName = value;
  }
  protected _displayName?: string;
}
